// @flow

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import { NightlyAlert } from "../../containers/Map/components";
import "./style.css";
import { drawingActions } from "../../store/actions";

function ModalComponent(props) {
  const { component, drawEnd, closePopup, openPopup } = props;
  const [open, setOpen] = useState(openPopup);
  const [close, setClose] = useState(closePopup);

  useEffect(() => {
    setClose(props.closePopup);
    setOpen(props.openPopup);
    if (props.openPopup === false) {
      props.drawing("completed");
    }
  }, [props]);

  const toggleButton = () => {
    setOpen(!open);
    //drawEnd: set to true
    if (drawEnd === true) {
      props.drawing("completed");
    }
  };

  const closeButton = () => {
    // setOpen(!open);
    props.closePopupAction('initialize')
    props.openPopupAction('close')
    setOpen(!open);
    setClose(true);
  };

  return (
    <>
      <Popup
        open={open}
        modal
        position="right center"
        closeOnDocumentClick={close}
        backdrop="static"
        closeOnEscape={false}
        // trigger={<button className="button"> Open Modal </button>}
      >
        <div className="custom-modal">
          <button className="btn-link close" onClick={closeButton}></button>
          <div className="transition visible active"></div>
            {component === "NightlyAlert" ? (
              <NightlyAlert toggleButton={toggleButton} />
            ) : (
              ""
            )}
        </div>
      </Popup>
    </>
  );
}

function mapStateToProps(state) {
  const { drawEnd, closePopup, openPopup } = state.drawing;
  return {
    drawEnd,
    openPopup,
    closePopup,
  };
}

const mapDispatchToProps = {
  closePopupAction: drawingActions.closePopup,
  openPopupAction: drawingActions.openPopup,
  drawing: drawingActions.drawing,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent);
